module.exports = __webpack_public_path__ + "static/media/togo.6ae80303.svg";